import "./Contact.css";
import { useState } from "react";
import Header from "../../Components/Shared/Header/Header";
import Footer from "../../Components/Shared/Footer/Footer";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { BASE_URL } from "../../constants/constant";

const CONTACT_EMAIL = "rpvivavahbandh@gmail.com";

const formSchema = Yup.object().shape({
  name:  Yup.string().required("Name is required"),
  email: Yup.string().required("Email is required").email("Enter a valid email"),
  phone: Yup.string().required("Phone number is required").matches(/^[0-9+\-\s()]{7,15}$/, "Enter a valid phone number"),
  notes: Yup.string(),
});

function Contact() {
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);
  const { register, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(formSchema) });

  const onSubmit = async (data) => {
    setError(null);
    try {
      const res = await fetch(`${BASE_URL}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: data.name, email: data.email, phone: data.phone, message: data.notes || '' }),
      });
      if (!res.ok) throw new Error('Failed to send');
      setSent(true);
    } catch {
      setError('Something went wrong. Please email us directly at ' + CONTACT_EMAIL);
    }
  };

  return (
    <div className="gla_page" id="gla_page">
      <a href="#gla_page" className="gla_top ti ti-angle-up gla_go"></a>
      <Header />

      <div className="gla_page_title gla_image_bck gla_wht_txt" data-color="#282828">
        <div className="container text-left">
          <div className="row">
            <div className="col-md-8">
              <h1 className="gla_h1_title">Contact Us</h1>
            </div>
            <div className="col-md-4">
              <div className="breadcrumbs">
                <a href="/">Home</a>
                <span>Contact Us</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section id="gla_content" className="gla_content">
        <section className="gla_section">
          <div className="container text-center">
            <p>
              <img src="/images/animations/rsvp.gif" alt="" style={{ height: '220px' }} />
            </p>
            <div className="row">
              <div className="col-md-8 col-md-push-2">

                {sent ? (
                  <div className="contact-success">
                    <div className="contact-success-icon">
                      <i className="ti ti-check"></i>
                    </div>
                    <h3>Message received!</h3>
                    <p>Thank you for reaching out. We'll get back to you as soon as possible.</p>
                    <button className="btn submit" onClick={() => setSent(false)}>
                      Send Another Message
                    </button>
                  </div>
                ) : (
                  <div className="contact-form-card">
                    <h3 className="contact-form-title">Get in Touch</h3>
                    <p className="contact-form-sub">Fill in the form and we'll get back to you as soon as possible.</p>
                    {error && <div style={{color:'#e91e63',marginBottom:'12px',fontSize:'14px'}}>{error}</div>}
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="row">
                        <div className="col-md-4">
                          <label>Your Name *</label>
                          <input
                            type="text"
                            {...register("name")}
                            className={`form-control ${errors.name ? "is-invalid" : ""}`}
                            placeholder="Full name"
                          />
                          <span className="invalid-feedback">{errors.name?.message}</span>
                        </div>
                        <div className="col-md-4">
                          <label>Email Address *</label>
                          <input
                            type="email"
                            {...register("email")}
                            className={`form-control ${errors.email ? "is-invalid" : ""}`}
                            placeholder="you@example.com"
                          />
                          <span className="invalid-feedback">{errors.email?.message}</span>
                        </div>
                        <div className="col-md-4">
                          <label>Phone Number *</label>
                          <input
                            type="text"
                            {...register("phone")}
                            className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                            placeholder="+91 98765 43210"
                          />
                          <span className="invalid-feedback">{errors.phone?.message}</span>
                        </div>
                        <div className="col-md-12">
                          <label>Message</label>
                          <textarea
                            {...register("notes")}
                            className="form-control"
                            placeholder="How can we help you?"
                            rows={4}
                          />
                        </div>
                        <div className="col-md-12">
                          <button type="submit" className="btn submit">
                            <i className="ti ti-email"></i> Send Message
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                )}

              </div>
            </div>
          </div>
        </section>
      </section>

      {/* Info strip */}
      <section id="grey" className="gla_section gla_image_bck gla_wht_txt" data-color="#292929">
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-sm-4">
              <h4><i className="ti ti-location-pin"></i> Address</h4>
              <p>
                Desale Pada, Dombivali East<br />
                Thane, Maharashtra – 421204
              </p>
            </div>
            <div className="col-md-4 col-sm-4">
              <h4><i className="ti ti-timer"></i> Working Hours</h4>
              <ul className="list-unstyled">
                <li><strong>Monday – Friday:</strong> 10am to 6pm</li>
                <li><strong>Saturday:</strong> 10am to 2pm</li>
                <li><strong>Sunday:</strong> Closed</li>
              </ul>
            </div>
            <div className="col-md-4 col-sm-4">
              <h4><i className="ti ti-email"></i> Email Us</h4>
              <p>
                <a href={`mailto:${CONTACT_EMAIL}`} style={{ color: "#f9a8d4" }}>
                  {CONTACT_EMAIL}
                </a>
              </p>
              <p style={{ fontSize: "13px", opacity: 0.8 }}>
                We're happy to answer your questions and assist you.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Contact;
